import { Home, StakingPage, Dashboard, Explorer } from './pages'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { WagmiProvider } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { config } from './config.jsx'

import toast, { ToastBar, Toaster } from 'react-hot-toast'
import { Buffer } from 'buffer';

const projectId = '5cce32de6c9d5cd028b2b9974761bb76'

const queryClient = new QueryClient()

const metadata = {
  name: 'R0AR-Society',
  description: 'R0AR NFT Minting and Staking Site',
  url: 'https://roarsociety.io',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [mainnet]

const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })

const r0artestnet = {
  id: 11166111,
  network: "r0artestnet",
  name: "R0ARTestNet",
  nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
  },
  rpcUrls: {
      default: {
          http: ["https://testnet.rpc-r0ar.io"],
      },
  },
  blockExplorers: {
      default: {
          name: "R0AR Testnet Exploerer",
          url: "https://testnet.r0arscan.io",
      },
  },
  testnet: true,
};

createWeb3Modal({
  themeVariables: {
    '--w3m-accent': '#1f1f1f',
    '--w3m-border-radius-master': '1px'
  },
  projectId,
  metadata,
  wagmiConfig
})

function App() {

  return (
    <div className='App'>
      <WagmiProvider reconnectOnMount config={config}>
        <Toaster
          position="top-right"
          reverseOrder={true}
          toastOptions={{ duration: 5000 }}
        >
          {t => (
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => toast.dismiss(t.id)}
            >
              <ToastBar onClick={() => alert(1)} toast={t} />
            </div>
          )}
        </Toaster>
        <Router>
          <Routes>
            <Route path="/" element={<Explorer />} />
            {/* <Route path="/mint" element={<MintPage />} /> */}
            <Route path="/staking" element={<StakingPage />} />
            <Route path="/explorer" element={<Explorer />} />
            <Route path="/owner-dashboard" element={<Dashboard />} />
          </Routes>
        </Router>
      </WagmiProvider>
    </div>
  );
}

export default App;
